import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import termsContent from '@/content/terms.md?raw';

const TermsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 bg-noise flex flex-col">
      <div className="max-w-4xl mx-auto px-6 py-12 flex-1 w-full">
        {/* Header */}
        <div className="mb-10 animate-fade-in">
          <Button
            variant="outline"
            onClick={() => navigate('/')}
            className="group hover:bg-white hover:shadow-md transition-all duration-200 border-slate-200 rounded-xl"
          >
            <ArrowLeft className="w-4 h-4 mr-2 group-hover:-translate-x-1 transition-transform" />
            Back
          </Button>
        </div>

        {/* Content */}
        <div className="bg-white rounded-[32px] shadow-sm border border-slate-100 p-10 md:p-16 animate-scale-in">
          <div className="prose prose-slate prose-lg max-w-none prose-headings:tracking-tight prose-headings:font-bold prose-a:text-blue-600 prose-img:rounded-3xl prose-table:border prose-table:border-slate-100">
            <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              components={{
                h1: ({ children }) => (
                  <h1 className="text-4xl font-bold text-slate-900 mb-6">{children}</h1>
                ),
                h2: ({ children }) => (
                  <h2 className="text-2xl font-bold text-slate-800 mb-4 mt-12 pb-2 border-b border-slate-100">{children}</h2>
                ),
                h3: ({ children }) => (
                  <h3 className="text-xl font-semibold text-slate-800 mb-3 mt-8">{children}</h3>
                ),
                p: ({ children }) => (
                  <p className="text-slate-600 leading-relaxed mb-6">{children}</p>
                ),
                ul: ({ children }) => (
                  <ul className="list-disc pl-6 text-slate-600 space-y-2 mb-6">{children}</ul>
                ),
                li: ({ children }) => (
                  <li className="text-slate-600">{children}</li>
                ),
                blockquote: ({ children }) => (
                  <blockquote className="border-l-4 border-blue-500 bg-blue-50/50 p-6 my-8 rounded-r-2xl text-slate-700 italic">
                    {children}
                  </blockquote>
                ),
                table: ({ children }) => (
                  <div className="my-8 overflow-hidden rounded-2xl border border-slate-100 shadow-sm overflow-x-auto">
                    <table className="w-full text-sm text-left">
                      {children}
                    </table>
                  </div>
                ),
                thead: ({ children }) => (
                  <thead className="bg-slate-50 text-slate-900 font-semibold border-b border-slate-100">
                    {children}
                  </thead>
                ),
                th: ({ children }) => (
                  <th className="px-6 py-4">{children}</th>
                ),
                td: ({ children }) => (
                  <td className="px-6 py-4 border-b border-slate-50 text-slate-600">{children}</td>
                ),
                hr: () => <hr className="my-12 border-slate-100" />
              }}
            >
              {termsContent}
            </ReactMarkdown>
          </div>
        </div>

        {/* Bottom copyright notice */}
        <div className="mt-12 text-center pb-8 animate-fade-in" style={{ animationDelay: '200ms' }}>
          <p className="text-slate-400 text-sm font-medium">
            © 2025 StudiBudi. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
